<template>
<v-content>
  <v-card width="95%" max-width="600px" class="mx-auto mt-5 pb-1">
    <v-card-title>
      <h1 class="display-2">Page Not Found</h1> <v-spacer></v-spacer>
      <h2 class="display-3">404</h2>
    </v-card-title>
    <p style="padding:10px">
      The specified location was not found on this website. Please check the URL for mistakes and try again.
    </p>
  </v-card>
</v-content>
</template>

<script>
export default {

}
</script>